import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import ModeEditIcon from '@mui/icons-material/ModeEdit';


export function SaveModel({ onSubmit, selectedItem, isLoading = false }: { onSubmit: any, selectedItem: any, isLoading?: boolean }) {

    return (
        <>
            <Button onClick={() => onSubmit()} variant='contained' sx={{ padding: '4px 8px', color: '#3150A1' }} disabled={isLoading}>
                <Stack direction='row' spacing={1} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                    {
                        isLoading ? <CircularProgress size={20} color="inherit" /> : selectedItem ? <ModeEditIcon sx={{ color: 'white' }} /> : <DoneIcon sx={{ color: 'white' }} />
                    }
                    <Typography sx={{ fontSize: '12px', color: isLoading ? 'gray' : 'white' }}>
                        {selectedItem ? 'Edit' : 'Save'}
                    </Typography>
                </Stack>
            </Button>
        </>
    );
}